var _a;
import { IdResource } from "../constants/IdResource";
export var resourcesConfig = (_a = {},
    _a[IdResource.AdventureCoins] = {
        canBeBought: false,
    },
    _a[IdResource.Books] = {
        canBeBought: false,
    },
    _a[IdResource.BuildCoupons] = {
        canBeBought: false,
    },
    _a[IdResource.ChestKeys] = {
        canBeBought: false,
    },
    _a[IdResource.CoopFunds] = {
        canBeBought: false,
    },
    _a[IdResource.DecoCoupons] = {
        canBeBought: false,
    },
    _a[IdResource.DogtreatPremium] = {
        canBeBought: true,
    },
    _a[IdResource.DogtreatStandard] = {
        canBeBought: true,
    },
    _a[IdResource.FertilizerSeaweed] = {
        canBeBought: true,
    },
    _a[IdResource.Gold] = {
        canBeBought: true,
    },
    _a[IdResource.HumusSeaweed] = {
        canBeBought: true,
    },
    _a[IdResource.InkSets] = {
        canBeBought: false,
    },
    _a[IdResource.LoyaltyPoints] = {
        canBeBought: true,
    },
    _a[IdResource.Money] = {
        canBeBought: true,
    },
    _a[IdResource.PawPrints] = {
        canBeBought: false,
    },
    _a[IdResource.Scrolls] = {
        canBeBought: false,
    },
    _a[IdResource.Snippets] = {
        canBeBought: false,
    },
    _a[IdResource.SpecialCoupons] = {
        canBeBought: false,
    },
    _a[IdResource.TournamentCoins] = {
        canBeBought: false,
    },
    _a[IdResource.Water] = {
        canBeBought: true,
    },
    _a[IdResource.VictoryCoins] = {
        canBeBought: false,
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/setup/resourcesConfig.ts
// module id = 2830
// module chunks = 3